<template>
  <a-tag :color="color">{{ label }}</a-tag>
</template>

<script>
// SYNC WITH src/views/domains/components/HealthTag.vue
const MAP = {
  healthy:  { color: 'green',  label: '健康' },
  warning:  { color: 'orange', label: '警告' },
  critical: { color: 'red',    label: '危险' },
  unknown:  { color: 'default', label: '未检测' },
}
export default {
  name: 'HealthTag',
  props: { status: { type: String, default: 'unknown' } },
  computed: {
    color() { return (MAP[this.status] || MAP.unknown).color },
    label() { return (MAP[this.status] || MAP.unknown).label },
  },
}
</script>
